import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

export const useProjectConnectionQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    invites: () =>
      queryOptions({
        queryKey: QUERY_KEYS.PROJECT_CONNECTION_INVITES(projectId),
        queryFn: () => api.getProjectConnectionsInvitesV1(),
        select: commonAPIDataSelector,
      }),

    list: (params?: ApiQueryParams<"getProjectConnectionsV1">) =>
      queryOptions({
        queryKey: QUERY_KEYS.PROJECT_CONNECTION_LIST_INCLUDE_ALL(
          projectId,
          params || { Limit: 1000, Offset: 0, IncludeAllFromProfile: true },
        ),
        queryFn: () => api.getProjectConnectionsV1(params || { Limit: 1000, Offset: 0, IncludeAllFromProfile: true }),
        select: commonAPIDataSelector,
      }),

    details: (id: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.PROJECT_CONNECTION_DETAILS(id),
        queryFn: () => api.getProjectConnectionsDetailsV1(id),
        select: commonAPIDataSelector,
      }),
  };
};
